import { render, staticRenderFns } from "./ChevronIcon.vue?vue&type=template&id=d4671d66&scoped=true"
import script from "./ChevronIcon.vue?vue&type=script&lang=js"
export * from "./ChevronIcon.vue?vue&type=script&lang=js"
import style0 from "./ChevronIcon.vue?vue&type=style&index=0&id=d4671d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4671d66",
  null
  
)

export default component.exports